export default {

  speed: {x: 2, y: 0},
  farStartMove: 1.01,
  deepChangeAnimation: 1.12,
  land: [
    {
      "x": -3100
    },
    {
      "x": -3100.44
    },
    {
      "x": -3103.96
    },
    {
      "x": -3107.47
    },
    {
      "x": -3111.41
    },
    {
      "x": -3114.91
    },
    {
      "x": -3118.4
    },
    {
      "x": -3122.33
    },
    {
      "x": -3125.81
    },
    {
      "x": -3129.72
    },
    {
      "x": -3133.19
    },
    {
      "x": -3136.65
    },
    {
      "x": -3140.11
    },
    {
      "x": -3143.99
    },
    {
      "x": -3147.44
    },
    {
      "x": -3150.88
    },
    {
      "x": -3154.74
    },
    {
      "x": -3158.17
    },
    {
      "x": -3162.45
    },
    {
      "x": -3165.44
    },
    {
      "x": -3168.85
    },
    {
      "x": -3172.25
    },
    {
      "x": -3176.08
    },
    {
      "x": -3179.47
    },
    {
      "x": -3182.86
    },
    {
      "x": -3186.66
    },
    {
      "x": -3190.04
    },
    {
      "x": -3193.41
    },
    {
      "x": -3197.19
    },
    {
      "x": -3200.55
    },
    {
      "x": -3204.32
    },
    {
      "x": -3207.67
    },
    {
      "x": -3211.01
    },
    {
      "x": -3214.34
    },
    {
      "x": -3218.09
    },
    {
      "x": -3221.41
    },
    {
      "x": -3224.73
    },
    {
      "x": -3228.45
    },
    {
      "x": -3231.76
    },
    {
      "x": -3235.06
    },
    {
      "x": -3238.76
    },
    {
      "x": -3242.05
    },
    {
      "x": -3245.33
    },
    {
      "x": -3249.02
    },
    {
      "x": -3252.29
    },
    {
      "x": -3255.55
    },
    {
      "x": -3259.22
    },
    {
      "x": -3262.47
    },
    {
      "x": -3265.72
    },
    {
      "x": -3269.36
    },
    {
      "x": -3272.6
    },
    {
      "x": -3275.83
    },
    {
      "x": -3279.46
    },
    {
      "x": -3282.67
    },
    {
      "x": -3286.29
    },
    {
      "x": -3289.49
    },
    {
      "x": -3292.69
    },
    {
      "x": -3295.88
    },
    {
      "x": -3299.47
    },
    {
      "x": -3302.65
    },
    {
      "x": -3305.83
    },
    {
      "x": -3309.4
    },
    {
      "x": -3312.56
    },
    {
      "x": -3315.72
    },
    {
      "x": -3319.27
    },
    {
      "x": -3322.41
    },
    {
      "x": -3325.55
    },
    {
      "x": -3329.08
    },
    {
      "x": -3332.21
    },
    {
      "x": -3335.33
    },
    {
      "x": -3338.84
    },
    {
      "x": -3341.95
    },
    {
      "x": -3345.06
    },
    {
      "x": -3348.55
    },
    {
      "x": -3351.64
    },
    {
      "x": -3354.73
    },
    {
      "x": -3358.2
    },
    {
      "x": -3361.27
    },
    {
      "x": -3364.34
    },
    {
      "x": -3367.79
    },
    {
      "x": -3370.85
    },
    {
      "x": -3373.9
    },
    {
      "x": -3377.33
    },
    {
      "x": -3380.37
    },
    {
      "x": -3383.41
    },
    {
      "x": -3386.82
    },
    {
      "x": -3389.84
    },
    {
      "x": -3392.86
    },
    {
      "x": -3396.25
    },
    {
      "x": -3399.25
    },
    {
      "x": -3402.63
    },
    {
      "x": -3405.62
    },
    {
      "x": -3408.61
    },
    {
      "x": -3411.6
    },
    {
      "x": -3414.94
    },
    {
      "x": -3417.92
    },
    {
      "x": -3420.88
    },
    {
      "x": -3424.21
    },
    {
      "x": -3427.16
    },
    {
      "x": -3430.11
    },
    {
      "x": -3433.42
    },
    {
      "x": -3436.36
    },
    {
      "x": -3439.29
    },
    {
      "x": -3442.58
    },
    {
      "x": -3445.49
    },
    {
      "x": -3448.41
    },
    {
      "x": -3451.68
    },
    {
      "x": -3454.58
    },
    {
      "x": -3457.83
    },
    {
      "x": -3460.72
    },
    {
      "x": -3463.6
    },
    {
      "x": -3466.48
    },
    {
      "x": -3469.71
    },
    {
      "x": -3472.58
    },
    {
      "x": -3475.44
    },
    {
      "x": -3478.65
    },
    {
      "x": -3481.49
    },
    {
      "x": -3484.34
    },
    {
      "x": -3487.53
    },
    {
      "x": -3490.36
    },
    {
      "x": -3493.18
    },
    {
      "x": -3496.35
    },
    {
      "x": -3499.16
    },
    {
      "x": -3501.97
    },
    {
      "x": -3505.12
    },
    {
      "x": -3507.92
    },
    {
      "x": -3511.05
    },
    {
      "x": -3513.84
    },
    {
      "x": -3516.61
    },
    {
      "x": -3519.39
    },
    {
      "x": -3522.5
    },
    {
      "x": -3525.26
    },
    {
      "x": -3528.01
    },
    {
      "x": -3531.1
    },
    {
      "x": -3533.85
    },
    {
      "x": -3536.58
    },
    {
      "x": -3539.65
    },
    {
      "x": -3542.38
    },
    {
      "x": -3545.1
    },
    {
      "x": -3548.15
    },
    {
      "x": -3550.86
    },
    {
      "x": -3553.56
    },
    {
      "x": -3556.59
    },
    {
      "x": -3559.28
    },
    {
      "x": -3562.3
    },
    {
      "x": -3564.97
    },
    {
      "x": -3567.65
    },
    {
      "x": -3570.31
    },
    {
      "x": -3573.3
    },
    {
      "x": -3575.96
    },
    {
      "x": -3578.94
    },
    {
      "x": -3581.58
    },
    {
      "x": -3584.22
    },
    {
      "x": -3587.18
    },
    {
      "x": -3589.8
    },
    {
      "x": -3592.42
    },
    {
      "x": -3595.36
    },
    {
      "x": -3597.97
    },
    {
      "x": -3600.57
    },
    {
      "x": -3603.49
    },
    {
      "x": -3606.08
    },
    {
      "x": -3608.98
    },
    {
      "x": -3611.56
    },
    {
      "x": -3614.13
    },
    {
      "x": -3616.7
    },
    {
      "x": -3619.58
    },
    {
      "x": -3622.13
    },
    {
      "x": -3624.68
    },
    {
      "x": -3627.54
    },
    {
      "x": -3630.08
    },
    {
      "x": -3632.61
    },
    {
      "x": -3635.45
    },
    {
      "x": -3637.97
    },
    {
      "x": -3640.48
    },
    {
      "x": -3643.3
    },
    {
      "x": -3645.8
    },
    {
      "x": -3648.3
    },
    {
      "x": -3651.1
    },
    {
      "x": -3653.58
    },
    {
      "x": -3656.06
    },
    {
      "x": -3658.84
    },
    {
      "x": -3661.31
    },
    {
      "x": -3663.77
    },
    {
      "x": -3666.53
    },
    {
      "x": -3668.98
    },
    {
      "x": -3671.42
    },
    {
      "x": -3674.16
    },
    {
      "x": -3676.59
    },
    {
      "x": -3679.02
    },
    {
      "x": -3681.74
    },
    {
      "x": -3684.15
    },
    {
      "x": -3686.56
    },
    {
      "x": -3689.26
    },
    {
      "x": -3691.66
    },
    {
      "x": -3694.05
    },
    {
      "x": -3696.73
    },
    {
      "x": -3699.11
    },
    {
      "x": -3701.48
    },
    {
      "x": -3704.14
    },
    {
      "x": -3706.5
    },
    {
      "x": -3708.86
    },
    {
      "x": -3711.5
    },
    {
      "x": -3713.85
    },
    {
      "x": -3716.18
    },
    {
      "x": -3718.81
    },
    {
      "x": -3721.13
    },
    {
      "x": -3723.45
    },
    {
      "x": -3726.05
    },
    {
      "x": -3728.36
    },
    {
      "x": -3730.66
    },
    {
      "x": -3733.25
    },
    {
      "x": -3735.54
    },
    {
      "x": -3737.82
    },
    {
      "x": -3740.38
    },
    {
      "x": -3742.66
    },
    {
      "x": -3744.92
    },
    {
      "x": -3747.47
    },
    {
      "x": -3749.72
    },
    {
      "x": -3751.97
    },
    {
      "x": -3754.49
    },
    {
      "x": -3756.73
    },
    {
      "x": -3758.96
    },
    {
      "x": -3761.47
    },
    {
      "x": -3763.69
    },
    {
      "x": -3765.9
    },
    {
      "x": -3768.39
    },
    {
      "x": -3770.59
    },
    {
      "x": -3772.78
    },
    {
      "x": -3775.25
    },
    {
      "x": -3777.43
    },
    {
      "x": -3779.61
    },
    {
      "x": -3782.06
    },
    {
      "x": -3784.22
    },
    {
      "x": -3786.38
    },
    {
      "x": -3788.81
    },
    {
      "x": -3790.96
    },
    {
      "x": -3793.1
    },
    {
      "x": -3795.51
    },
    {
      "x": -3797.64
    },
    {
      "x": -3799.76
    },
    {
      "x": -3802.15
    },
    {
      "x": -3804.26
    },
    {
      "x": -3806.37
    },
    {
      "x": -3808.74
    },
    {
      "x": -3810.83
    },
    {
      "x": -3812.93
    },
    {
      "x": -3815.27
    },
    {
      "x": -3817.35
    },
    {
      "x": -3819.42
    },
    {
      "x": -3821.75
    },
    {
      "x": -3823.81
    },
    {
      "x": -3825.87
    },
    {
      "x": -3828.17
    },
    {
      "x": -3830.22
    },
    {
      "x": -3832.25
    },
    {
      "x": -3834.54
    },
    {
      "x": -3836.57
    },
    {
      "x": -3838.59
    },
    {
      "x": -3840.85
    },
    {
      "x": -3842.86
    },
    {
      "x": -3844.86
    },
    {
      "x": -3847.11
    },
    {
      "x": -3849.1
    },
    {
      "x": -3851.09
    },
    {
      "x": -3853.31
    },
    {
      "x": -3855.29
    },
    {
      "x": -3857.25
    },
    {
      "x": -3859.46
    },
    {
      "x": -3861.42
    },
    {
      "x": -3863.37
    },
    {
      "x": -3865.55
    },
    {
      "x": -3867.49
    },
    {
      "x": -3869.67
    },
    {
      "x": -3871.59
    },
    {
      "x": -3873.51
    },
    {
      "x": -3875.43
    },
    {
      "x": -3877.57
    },
    {
      "x": -3879.48
    },
    {
      "x": -3881.37
    },
    {
      "x": -3883.5
    },
    {
      "x": -3885.39
    },
    {
      "x": -3887.27
    },
    {
      "x": -3889.38
    },
    {
      "x": -3891.24
    },
    {
      "x": -3893.11
    },
    {
      "x": -3895.19
    },
    {
      "x": -3897.04
    },
    {
      "x": -3899.12
    },
    {
      "x": -3900.96
    },
    {
      "x": -3902.79
    },
    {
      "x": -3904.62
    },
    {
      "x": -3906.66
    },
    {
      "x": -3908.48
    },
    {
      "x": -3910.29
    },
    {
      "x": -3912.32
    },
    {
      "x": -3914.11
    },
    {
      "x": -3915.91
    },
    {
      "x": -3917.91
    },
    {
      "x": -3919.69
    },
    {
      "x": -3921.47
    },
    {
      "x": -3923.46
    },
    {
      "x": -3925.22
    },
    {
      "x": -3926.98
    },
    {
      "x": -3928.95
    },
    {
      "x": -3930.69
    },
    {
      "x": -3932.43
    },
    {
      "x": -3934.38
    },
    {
      "x": -3936.11
    },
    {
      "x": -3937.83
    },
    {
      "x": -3939.76
    },
    {
      "x": -3941.47
    },
    {
      "x": -3943.17
    },
    {
      "x": -3945.08
    },
    {
      "x": -3946.77
    },
    {
      "x": -3948.46
    },
    {
      "x": -3950.35
    },
    {
      "x": -3952.02
    },
    {
      "x": -3953.9
    },
    {
      "x": -3955.56
    },
    {
      "x": -3957.22
    },
    {
      "x": -3958.87
    },
    {
      "x": -3960.72
    },
    {
      "x": -3962.36
    },
    {
      "x": -3964.19
    },
    {
      "x": -3965.82
    },
    {
      "x": -3967.44
    },
    {
      "x": -3969.06
    },
    {
      "x": -3970.87
    },
    {
      "x": -3972.47
    },
    {
      "x": -3974.07
    },
    {
      "x": -3975.86
    },
    {
      "x": -3977.45
    },
    {
      "x": -3979.23
    },
    {
      "x": -3980.8
    },
    {
      "x": -3982.37
    },
    {
      "x": -3984.13
    },
    {
      "x": -3985.68
    },
    {
      "x": -3987.23
    },
    {
      "x": -3988.97
    },
    {
      "x": -3990.51
    },
    {
      "x": -3992.04
    },
    {
      "x": -3993.76
    },
    {
      "x": -3995.28
    },
    {
      "x": -3996.8
    },
    {
      "x": -3998.5
    },
    {
      "x": -4000
    },
    {
      "x": -4001.5
    },
    {
      "x": -4003.18
    },
    {
      "x": -4004.66
    },
    {
      "x": -4006.14
    },
    {
      "x": -4007.8
    },
    {
      "x": -4009.27
    },
    {
      "x": -4010.74
    },
    {
      "x": -4012.37
    },
    {
      "x": -4013.83
    },
    {
      "x": -4015.27
    },
    {
      "x": -4016.89
    },
    {
      "x": -4018.32
    },
    {
      "x": -4019.75
    },
    {
      "x": -4021.35
    },
    {
      "x": -4022.77
    },
    {
      "x": -4024.18
    },
    {
      "x": -4025.76
    },
    {
      "x": -4027.15
    },
    {
      "x": -4028.55
    },
    {
      "x": -4030.11
    },
    {
      "x": -4031.49
    },
    {
      "x": -4032.86
    },
    {
      "x": -4034.4
    },
    {
      "x": -4035.76
    },
    {
      "x": -4037.12
    },
    {
      "x": -4038.64
    },
    {
      "x": -4039.99
    },
    {
      "x": -4041.33
    },
    {
      "x": -4042.83
    },
    {
      "x": -4044.16
    },
    {
      "x": -4045.48
    },
    {
      "x": -4046.96
    },
    {
      "x": -4048.27
    },
    {
      "x": -4049.57
    },
    {
      "x": -4051.03
    },
    {
      "x": -4052.33
    },
    {
      "x": -4053.61
    },
    {
      "x": -4055.05
    },
    {
      "x": -4056.33
    },
    {
      "x": -4057.6
    },
    {
      "x": -4059.02
    },
    {
      "x": -4060.28
    },
    {
      "x": -4061.53
    },
    {
      "x": -4062.93
    },
    {
      "x": -4064.17
    },
    {
      "x": -4065.4
    },
    {
      "x": -4066.79
    },
    {
      "x": -4068.01
    },
    {
      "x": -4069.22
    },
    {
      "x": -4070.59
    },
    {
      "x": -4071.79
    },
    {
      "x": -4072.99
    },
    {
      "x": -4074.33
    },
    {
      "x": -4075.52
    },
    {
      "x": -4076.7
    },
    {
      "x": -4078.02
    },
    {
      "x": -4079.19
    },
    {
      "x": -4080.36
    },
    {
      "x": -4081.66
    },
    {
      "x": -4082.81
    },
    {
      "x": -4083.96
    },
    {
      "x": -4085.24
    },
    {
      "x": -4086.37
    },
    {
      "x": -4087.5
    },
    {
      "x": -4088.76
    },
    {
      "x": -4089.88
    },
    {
      "x": -4091.13
    },
    {
      "x": -4092.23
    },
    {
      "x": -4093.33
    },
    {
      "x": -4094.43
    },
    {
      "x": -4095.65
    },
    {
      "x": -4096.73
    },
    {
      "x": -4097.81
    },
    {
      "x": -4099.01
    },
    {
      "x": -4100.07
    },
    {
      "x": -4101.13
    },
    {
      "x": -4102.32
    },
    {
      "x": -4103.36
    },
    {
      "x": -4104.4
    },
    {
      "x": -4105.57
    },
    {
      "x": -4106.59
    },
    {
      "x": -4107.62
    },
    {
      "x": -4108.76
    },
    {
      "x": -4109.77
    },
    {
      "x": -4110.78
    },
    {
      "x": -4111.9
    },
    {
      "x": -4112.9
    },
    {
      "x": -4113.88
    },
    {
      "x": -4114.99
    },
    {
      "x": -4115.96
    },
    {
      "x": -4116.93
    },
    {
      "x": -4118.02
    },
    {
      "x": -4118.98
    },
    {
      "x": -4119.93
    },
    {
      "x": -4120.99
    },
    {
      "x": -4121.93
    },
    {
      "x": -4122.87
    },
    {
      "x": -4123.91
    },
    {
      "x": -4124.84
    },
    {
      "x": -4125.75
    },
    {
      "x": -4126.78
    },
    {
      "x": -4127.68
    },
    {
      "x": -4128.58
    },
    {
      "x": -4129.59
    },
    {
      "x": -4130.48
    },
    {
      "x": -4131.36
    },
    {
      "x": -4132.35
    },
    {
      "x": -4133.22
    },
    {
      "x": -4134.08
    },
    {
      "x": -4135.05
    },
    {
      "x": -4135.9
    },
    {
      "x": -4136.75
    },
    {
      "x": -4137.69
    },
    {
      "x": -4138.53
    },
    {
      "x": -4139.36
    },
    {
      "x": -4140.28
    },
    {
      "x": -4141.1
    },
    {
      "x": -4141.91
    },
    {
      "x": -4142.82
    },
    {
      "x": -4143.62
    },
    {
      "x": -4144.41
    },
    {
      "x": -4145.3
    },
    {
      "x": -4146.08
    },
    {
      "x": -4146.86
    },
    {
      "x": -4147.72
    },
    {
      "x": -4148.49
    },
    {
      "x": -4149.25
    },
    {
      "x": -4150.09
    },
    {
      "x": -4150.84
    },
    {
      "x": -4151.67
    },
    {
      "x": -4152.41
    },
    {
      "x": -4153.14
    },
    {
      "x": -4153.86
    },
    {
      "x": -4154.67
    },
    {
      "x": -4155.38
    },
    {
      "x": -4156.09
    },
    {
      "x": -4156.88
    },
    {
      "x": -4157.57
    },
    {
      "x": -4158.26
    },
    {
      "x": -4159.03
    },
    {
      "x": -4159.7
    },
    {
      "x": -4160.46
    },
    {
      "x": -4161.12
    },
    {
      "x": -4161.78
    },
    {
      "x": -4162.52
    },
    {
      "x": -4163.16
    },
    {
      "x": -4163.8
    },
    {
      "x": -4164.52
    },
    {
      "x": -4165.15
    },
    {
      "x": -4165.77
    },
    {
      "x": -4166.47
    },
    {
      "x": -4167.08
    },
    {
      "x": -4167.68
    },
    {
      "x": -4168.36
    },
    {
      "x": -4168.95
    },
    {
      "x": -4169.54
    },
    {
      "x": -4170.2
    },
    {
      "x": -4170.77
    },
    {
      "x": -4171.35
    },
    {
      "x": -4171.98
    },
    {
      "x": -4172.54
    },
    {
      "x": -4173.09
    },
    {
      "x": -4173.71
    },
    {
      "x": -4174.25
    },
    {
      "x": -4174.79
    },
    {
      "x": -4175.38
    },
    {
      "x": -4175.91
    },
    {
      "x": -4176.42
    },
    {
      "x": -4177
    },
    {
      "x": -4177.51
    },
    {
      "x": -4178.01
    },
    {
      "x": -4178.56
    },
    {
      "x": -4179.05
    },
    {
      "x": -4179.53
    },
    {
      "x": -4180.07
    },
    {
      "x": -4180.54
    },
    {
      "x": -4181.07
    },
    {
      "x": -4181.52
    },
    {
      "x": -4181.98
    },
    {
      "x": -4182.43
    },
    {
      "x": -4182.92
    },
    {
      "x": -4183.36
    },
    {
      "x": -4183.79
    },
    {
      "x": -4184.27
    },
    {
      "x": -4184.68
    },
    {
      "x": -4185.1
    },
    {
      "x": -4185.55
    },
    {
      "x": -4185.95
    },
    {
      "x": -4186.35
    },
    {
      "x": -4186.79
    },
    {
      "x": -4187.17
    },
    {
      "x": -4187.55
    },
    {
      "x": -4187.96
    },
    {
      "x": -4188.33
    },
    {
      "x": -4188.69
    },
    {
      "x": -4189.09
    },
    {
      "x": -4189.44
    },
    {
      "x": -4189.78
    },
    {
      "x": -4190.16
    },
    {
      "x": -4190.49
    },
    {
      "x": -4190.81
    },
    {
      "x": -4191.17
    },
    {
      "x": -4191.48
    },
    {
      "x": -4191.83
    },
    {
      "x": -4192.13
    },
    {
      "x": -4192.42
    },
    {
      "x": -4192.75
    },
    {
      "x": -4193.03
    },
    {
      "x": -4193.31
    },
    {
      "x": -4193.58
    },
    {
      "x": -4193.88
    },
    {
      "x": -4194.14
    },
    {
      "x": -4194.42
    },
    {
      "x": -4194.67
    },
    {
      "x": -4194.91
    },
    {
      "x": -4195.15
    },
    {
      "x": -4195.41
    },
    {
      "x": -4195.63
    },
    {
      "x": -4195.85
    },
    {
      "x": -4196.09
    },
    {
      "x": -4196.3
    },
    {
      "x": -4196.55
    },
    {
      "x": -4196.72
    },
    {
      "x": -4196.91
    },
    {
      "x": -4197.09
    },
    {
      "x": -4197.29
    },
    {
      "x": -4197.47
    },
    {
      "x": -4197.63
    },
    {
      "x": -4197.81
    },
    {
      "x": -4197.97
    },
    {
      "x": -4198.11
    },
    {
      "x": -4198.28
    },
    {
      "x": -4198.41
    },
    {
      "x": -4198.54
    },
    {
      "x": -4198.68
    },
    {
      "x": -4198.8
    },
    {
      "x": -4198.92
    },
    {
      "x": -4199.04
    },
    {
      "x": -4199.14
    },
    {
      "x": -4199.23
    },
    {
      "x": -4199.33
    },
    {
      "x": -4199.42
    },
    {
      "x": -4199.5
    },
    {
      "x": -4199.58
    },
    {
      "x": -4199.64
    },
    {
      "x": -4199.7
    },
    {
      "x": -4199.77
    },
    {
      "x": -4199.81
    },
    {
      "x": -4199.86
    },
    {
      "x": -4199.9
    },
    {
      "x": -4199.93
    },
    {
      "x": -4199.95
    },
    {
      "x": -4199.98
    },
    {
      "x": -4199.99
    },
    {
      "x": -4200
    }
  ],

  plane: [
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -449.58,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -446.23,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -442.89,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -439.15,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -435.84,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -432.55,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -428.85,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -425.59,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -422.33,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -418.69,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -415.46,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -411.85,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -408.65,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -405.47,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -402.3,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -398.75,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -395.61,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -392.09,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -388.97,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -385.87,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -382.79,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -379.33,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -376.27,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -373.23,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -369.82,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -366.81,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -363.8,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -360.44,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -357.47,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -354.51,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -351.2,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -348.26,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -345.35,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -342.08,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -339.19,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -335.95,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -333.09,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -330.25,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -327.41,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -324.24,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -321.43,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -318.29,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -315.52,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -312.75,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -310,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -306.92,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -304.2,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -301.49,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -298.46,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -295.78,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -292.79,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -290.13,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -287.5,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -284.55,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -281.94,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -279.34,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -276.44,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -273.87,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -271.32,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -268.46,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -265.94,
      "y": -195,
      "a": 2.29
    },
    {
      "x": -263.42,
      "y": -195,
      "a": 2.18
    },
    {
      "x": -260.61,
      "y": -195,
      "a": 2.06
    },
    {
      "x": -258.13,
      "y": -195,
      "a": 1.96
    },
    {
      "x": -255.66,
      "y": -195,
      "a": 1.85
    },
    {
      "x": -252.9,
      "y": -195,
      "a": 1.73
    },
    {
      "x": -250.46,
      "y": -195,
      "a": 1.63
    },
    {
      "x": -248.03,
      "y": -195,
      "a": 1.53
    },
    {
      "x": -245.32,
      "y": -195,
      "a": 1.41
    },
    {
      "x": -242.92,
      "y": -195,
      "a": 1.31
    },
    {
      "x": -240.53,
      "y": -195,
      "a": 1.21
    },
    {
      "x": -237.86,
      "y": -195,
      "a": 1.1
    },
    {
      "x": -235.51,
      "y": -195,
      "a": 1
    },
    {
      "x": -233.16,
      "y": -195,
      "a": 0.9
    },
    {
      "x": -230.54,
      "y": -195,
      "a": 0.79
    },
    {
      "x": -228.23,
      "y": -195,
      "a": 0.69
    },
    {
      "x": -225.93,
      "y": -195,
      "a": 0.59
    },
    {
      "x": -223.35,
      "y": -195,
      "a": 0.48
    },
    {
      "x": -221.08,
      "y": -195,
      "a": 0.39
    },
    {
      "x": -218.82,
      "y": -195,
      "a": 0.29
    },
    {
      "x": -216.29,
      "y": -195,
      "a": 0.19
    },
    {
      "x": -214.06,
      "y": -195,
      "a": 0.09
    },
    {
      "x": -211.84,
      "y": -195,
      "a": 0
    },
    {
      "x": -209.37,
      "y": -195,
      "a": -0.11
    },
    {
      "x": -207.18,
      "y": -195,
      "a": -0.2
    },
    {
      "x": -205,
      "y": -195,
      "a": -0.29
    },
    {
      "x": -202.57,
      "y": -195,
      "a": -0.4
    },
    {
      "x": -200.42,
      "y": -195,
      "a": -0.49
    },
    {
      "x": -198.29,
      "y": -195,
      "a": -0.58
    },
    {
      "x": -195.91,
      "y": -195,
      "a": -0.68
    },
    {
      "x": -193.8,
      "y": -195,
      "a": -0.77
    },
    {
      "x": -191.45,
      "y": -195,
      "a": -0.87
    },
    {
      "x": -189.37,
      "y": -195,
      "a": -0.95
    },
    {
      "x": -187.31,
      "y": -195,
      "a": -1.04
    },
    {
      "x": -185,
      "y": -195,
      "a": -1.14
    },
    {
      "x": -182.97,
      "y": -195,
      "a": -1.23
    },
    {
      "x": -180.95,
      "y": -195,
      "a": -1.31
    },
    {
      "x": -178.94,
      "y": -195,
      "a": -1.4
    },
    {
      "x": -176.7,
      "y": -195,
      "a": -1.49
    },
    {
      "x": -174.72,
      "y": -195,
      "a": -1.57
    },
    {
      "x": -172.75,
      "y": -195,
      "a": -1.66
    },
    {
      "x": -170.56,
      "y": -195,
      "a": -1.75
    },
    {
      "x": -168.62,
      "y": -195,
      "a": -1.83
    },
    {
      "x": -166.7,
      "y": -195,
      "a": -1.91
    },
    {
      "x": -164.55,
      "y": -195,
      "a": -2
    },
    {
      "x": -162.65,
      "y": -195,
      "a": -2.08
    },
    {
      "x": -160.77,
      "y": -195,
      "a": -2.16
    },
    {
      "x": -158.67,
      "y": -195,
      "a": -2.25
    },
    {
      "x": -156.82,
      "y": -195,
      "a": -2.33
    },
    {
      "x": -154.98,
      "y": -195,
      "a": -2.41
    },
    {
      "x": -152.93,
      "y": -195,
      "a": -2.5
    },
    {
      "x": -151.11,
      "y": -195,
      "a": -2.57
    },
    {
      "x": -149.32,
      "y": -195,
      "a": -2.65
    },
    {
      "x": -147.31,
      "y": -195,
      "a": -2.73
    },
    {
      "x": -145.54,
      "y": -195,
      "a": -2.81
    },
    {
      "x": -143.57,
      "y": -195,
      "a": -2.89
    },
    {
      "x": -141.83,
      "y": -195,
      "a": -2.97
    },
    {
      "x": -140.1,
      "y": -195,
      "a": -3.04
    },
    {
      "x": -138.39,
      "y": -195,
      "a": -3.11
    },
    {
      "x": -136.48,
      "y": -195,
      "a": -3.19
    },
    {
      "x": -134.79,
      "y": -195.04,
      "a": -3.26
    },
    {
      "x": -133.12,
      "y": -195.39,
      "a": -3.34
    },
    {
      "x": -131.25,
      "y": -195.78,
      "a": -3.41
    },
    {
      "x": -129.61,
      "y": -196.12,
      "a": -3.48
    },
    {
      "x": -127.98,
      "y": -196.46,
      "a": -3.55
    },
    {
      "x": -125.96,
      "y": -196.89,
      "a": -3.64
    },
    {
      "x": -124.56,
      "y": -197.19,
      "a": -3.7
    },
    {
      "x": -122.98,
      "y": -197.53,
      "a": -3.76
    },
    {
      "x": -121.21,
      "y": -197.91,
      "a": -3.84
    },
    {
      "x": -119.65,
      "y": -198.25,
      "a": -3.91
    },
    {
      "x": -118.1,
      "y": -198.59,
      "a": -3.97
    },
    {
      "x": -116.38,
      "y": -198.97,
      "a": -4.04
    },
    {
      "x": -114.86,
      "y": -199.3,
      "a": -4.11
    },
    {
      "x": -113.36,
      "y": -199.64,
      "a": -4.17
    },
    {
      "x": -111.68,
      "y": -200.01,
      "a": -4.24
    },
    {
      "x": -110.21,
      "y": -200.35,
      "a": -4.3
    },
    {
      "x": -108.56,
      "y": -200.72,
      "a": -4.37
    },
    {
      "x": -107.12,
      "y": -201.05,
      "a": -4.44
    },
    {
      "x": -105.68,
      "y": -201.38,
      "a": -4.5
    },
    {
      "x": -104.09,
      "y": -201.75,
      "a": -4.56
    },
    {
      "x": -102.68,
      "y": -202.08,
      "a": -4.62
    },
    {
      "x": -101.29,
      "y": -202.4,
      "a": -4.68
    },
    {
      "x": -99.91,
      "y": -202.73,
      "a": -4.74
    },
    {
      "x": -98.38,
      "y": -203.09,
      "a": -4.81
    },
    {
      "x": -97.03,
      "y": -203.42,
      "a": -4.86
    },
    {
      "x": -95.7,
      "y": -203.74,
      "a": -4.92
    },
    {
      "x": -94.21,
      "y": -204.1,
      "a": -4.98
    },
    {
      "x": -92.9,
      "y": -204.42,
      "a": -5.04
    },
    {
      "x": -91.61,
      "y": -204.74,
      "a": -5.09
    },
    {
      "x": -90.17,
      "y": -205.1,
      "a": -5.15
    },
    {
      "x": -88.91,
      "y": -205.42,
      "a": -5.21
    },
    {
      "x": -87.65,
      "y": -205.74,
      "a": -5.26
    },
    {
      "x": -86.26,
      "y": -206.09,
      "a": -5.32
    },
    {
      "x": -85.04,
      "y": -206.41,
      "a": -5.37
    },
    {
      "x": -83.83,
      "y": -206.72,
      "a": -5.42
    },
    {
      "x": -82.48,
      "y": -207.08,
      "a": -5.48
    },
    {
      "x": -81.3,
      "y": -207.39,
      "a": -5.53
    },
    {
      "x": -79.99,
      "y": -207.74,
      "a": -5.58
    },
    {
      "x": -78.84,
      "y": -208.05,
      "a": -5.63
    },
    {
      "x": -77.7,
      "y": -208.36,
      "a": -5.68
    },
    {
      "x": -76.57,
      "y": -208.67,
      "a": -5.73
    },
    {
      "x": -75.32,
      "y": -209.01,
      "a": -5.78
    },
    {
      "x": -74.23,
      "y": -209.32,
      "a": -5.83
    },
    {
      "x": -73.01,
      "y": -209.66,
      "a": -5.88
    },
    {
      "x": -71.94,
      "y": -209.97,
      "a": -5.92
    },
    {
      "x": -70.88,
      "y": -210.27,
      "a": -5.97
    },
    {
      "x": -69.84,
      "y": -210.58,
      "a": -6.01
    },
    {
      "x": -68.69,
      "y": -210.91,
      "a": -6.06
    },
    {
      "x": -67.67,
      "y": -211.22,
      "a": -6.11
    },
    {
      "x": -66.67,
      "y": -211.52,
      "a": -6.15
    },
    {
      "x": -65.57,
      "y": -211.85,
      "a": -6.19
    },
    {
      "x": -64.59,
      "y": -212.15,
      "a": -6.24
    },
    {
      "x": -63.64,
      "y": -212.45,
      "a": -6.28
    },
    {
      "x": -62.58,
      "y": -212.78,
      "a": -6.32
    },
    {
      "x": -61.65,
      "y": -213.07,
      "a": -6.36
    },
    {
      "x": -60.73,
      "y": -213.37,
      "a": -6.4
    },
    {
      "x": -59.72,
      "y": -213.7,
      "a": -6.44
    },
    {
      "x": -58.83,
      "y": -213.99,
      "a": -6.48
    },
    {
      "x": -57.85,
      "y": -214.32,
      "a": -6.52
    },
    {
      "x": -56.99,
      "y": -214.61,
      "a": -6.56
    },
    {
      "x": -56.15,
      "y": -214.9,
      "a": -6.59
    },
    {
      "x": -55.21,
      "y": -215.22,
      "a": -6.63
    },
    {
      "x": -54.39,
      "y": -215.51,
      "a": -6.67
    },
    {
      "x": -53.59,
      "y": -215.8,
      "a": -6.7
    },
    {
      "x": -52.7,
      "y": -216.12,
      "a": -6.74
    },
    {
      "x": -51.93,
      "y": -216.4,
      "a": -6.77
    },
    {
      "x": -51.17,
      "y": -216.68,
      "a": -6.8
    },
    {
      "x": -50.42,
      "y": -216.97,
      "a": -6.84
    },
    {
      "x": -49.6,
      "y": -217.28,
      "a": -6.87
    },
    {
      "x": -48.88,
      "y": -217.56,
      "a": -6.9
    },
    {
      "x": -48.17,
      "y": -217.84,
      "a": -6.93
    },
    {
      "x": -47.39,
      "y": -218.16,
      "a": -6.96
    },
    {
      "x": -46.72,
      "y": -218.43,
      "a": -6.99
    },
    {
      "x": -45.97,
      "y": -218.75,
      "a": -7.02
    },
    {
      "x": -45.32,
      "y": -219.02,
      "a": -7.05
    },
    {
      "x": -44.69,
      "y": -219.3,
      "a": -7.08
    },
    {
      "x": -43.99,
      "y": -219.6,
      "a": -7.11
    },
    {
      "x": -43.38,
      "y": -219.88,
      "a": -7.13
    },
    {
      "x": -42.79,
      "y": -220.15,
      "a": -7.16
    },
    {
      "x": -42.14,
      "y": -220.45,
      "a": -7.19
    },
    {
      "x": -41.57,
      "y": -220.72,
      "a": -7.21
    },
    {
      "x": -41.02,
      "y": -220.99,
      "a": -7.23
    },
    {
      "x": -40.42,
      "y": -221.29,
      "a": -7.26
    },
    {
      "x": -39.9,
      "y": -221.56,
      "a": -7.28
    },
    {
      "x": -39.39,
      "y": -221.83,
      "a": -7.3
    },
    {
      "x": -38.83,
      "y": -222.13,
      "a": -7.33
    },
    {
      "x": -38.35,
      "y": -222.39,
      "a": -7.35
    },
    {
      "x": -37.88,
      "y": -222.65,
      "a": -7.37
    },
    {
      "x": -37.37,
      "y": -222.95,
      "a": -7.39
    },
    {
      "x": -36.94,
      "y": -223.21,
      "a": -7.41
    },
    {
      "x": -36.51,
      "y": -223.47,
      "a": -7.42
    },
    {
      "x": -36.1,
      "y": -223.73,
      "a": -7.44
    },
    {
      "x": -35.65,
      "y": -224.02,
      "a": -7.46
    },
    {
      "x": -35.27,
      "y": -224.28,
      "a": -7.48
    },
    {
      "x": -34.85,
      "y": -224.57,
      "a": -7.49
    },
    {
      "x": -34.5,
      "y": -224.82,
      "a": -7.51
    },
    {
      "x": -34.16,
      "y": -225.08,
      "a": -7.52
    },
    {
      "x": -33.83,
      "y": -225.33,
      "a": -7.54
    },
    {
      "x": -33.48,
      "y": -225.61,
      "a": -7.55
    },
    {
      "x": -33.18,
      "y": -225.87,
      "a": -7.57
    },
    {
      "x": -32.86,
      "y": -226.15,
      "a": -7.58
    },
    {
      "x": -32.59,
      "y": -226.4,
      "a": -7.59
    },
    {
      "x": -32.33,
      "y": -226.65,
      "a": -7.6
    },
    {
      "x": -32.06,
      "y": -226.93,
      "a": -7.61
    },
    {
      "x": -31.83,
      "y": -227.17,
      "a": -7.62
    },
    {
      "x": -31.61,
      "y": -227.42,
      "a": -7.63
    },
    {
      "x": -31.39,
      "y": -227.69,
      "a": -7.64
    },
    {
      "x": -31.2,
      "y": -227.94,
      "a": -7.65
    },
    {
      "x": -31.03,
      "y": -228.18,
      "a": -7.66
    },
    {
      "x": -30.85,
      "y": -228.45,
      "a": -7.66
    },
    {
      "x": -30.71,
      "y": -228.69,
      "a": -7.67
    },
    {
      "x": -30.57,
      "y": -228.93,
      "a": -7.68
    },
    {
      "x": -30.46,
      "y": -229.17,
      "a": -7.68
    },
    {
      "x": -30.34,
      "y": -229.44,
      "a": -7.69
    },
    {
      "x": -30.25,
      "y": -229.68,
      "a": -7.69
    },
    {
      "x": -30.18,
      "y": -229.91,
      "a": -7.69
    },
    {
      "x": -30.11,
      "y": -230.18,
      "a": -7.7
    },
    {
      "x": -30.06,
      "y": -230.41,
      "a": -7.7
    },
    {
      "x": -30.02,
      "y": -230.68,
      "a": -7.7
    },
    {
      "x": -30.01,
      "y": -230.91,
      "a": -7.7
    },
    {
      "x": -30,
      "y": -231.14,
      "a": -7.7
    },
    {
      "x": -30,
      "y": -231.4,
      "a": -7.61
    },
    {
      "x": -30,
      "y": -231.63,
      "a": -7.53
    },
    {
      "x": -30,
      "y": -231.86,
      "a": -7.45
    },
    {
      "x": -30,
      "y": -232.08,
      "a": -7.36
    },
    {
      "x": -30,
      "y": -232.34,
      "a": -7.27
    },
    {
      "x": -30,
      "y": -232.57,
      "a": -7.2
    },
    {
      "x": -30,
      "y": -232.79,
      "a": -7.12
    },
    {
      "x": -30,
      "y": -233.04,
      "a": -7.03
    },
    {
      "x": -30,
      "y": -233.26,
      "a": -6.95
    },
    {
      "x": -30,
      "y": -233.51,
      "a": -6.86
    },
    {
      "x": -30,
      "y": -233.76,
      "a": -6.77
    },
    {
      "x": -30,
      "y": -233.96,
      "a": -6.71
    },
    {
      "x": -30,
      "y": -234.2,
      "a": -6.62
    },
    {
      "x": -30,
      "y": -234.42,
      "a": -6.55
    },
    {
      "x": -30,
      "y": -234.64,
      "a": -6.47
    },
    {
      "x": -30,
      "y": -234.88,
      "a": -6.39
    },
    {
      "x": -30,
      "y": -235.09,
      "a": -6.31
    },
    {
      "x": -30,
      "y": -235.31,
      "a": -6.24
    },
    {
      "x": -30,
      "y": -235.55,
      "a": -6.15
    },
    {
      "x": -30,
      "y": -235.76,
      "a": -6.08
    },
    {
      "x": -30,
      "y": -236,
      "a": -6
    },
    {
      "x": -30,
      "y": -236.21,
      "a": -5.93
    },
    {
      "x": -30,
      "y": -236.42,
      "a": -5.85
    },
    {
      "x": -30,
      "y": -236.63,
      "a": -5.78
    },
    {
      "x": -30,
      "y": -236.86,
      "a": -5.7
    },
    {
      "x": -30,
      "y": -237.07,
      "a": -5.63
    },
    {
      "x": -30,
      "y": -237.27,
      "a": -5.56
    },
    {
      "x": -30,
      "y": -237.5,
      "a": -5.48
    },
    {
      "x": -30,
      "y": -237.7,
      "a": -5.42
    },
    {
      "x": -30,
      "y": -237.91,
      "a": -5.35
    },
    {
      "x": -30,
      "y": -238.13,
      "a": -5.27
    },
    {
      "x": -30,
      "y": -238.33,
      "a": -5.2
    },
    {
      "x": -30,
      "y": -238.53,
      "a": -5.14
    },
    {
      "x": -30,
      "y": -238.76,
      "a": -5.06
    },
    {
      "x": -30,
      "y": -238.96,
      "a": -4.99
    },
    {
      "x": -30,
      "y": -239.15,
      "a": -4.93
    },
    {
      "x": -30,
      "y": -239.37,
      "a": -4.85
    },
    {
      "x": -30,
      "y": -239.57,
      "a": -4.79
    },
    {
      "x": -30,
      "y": -239.76,
      "a": -4.72
    },
    {
      "x": -30,
      "y": -239.98,
      "a": -4.65
    },
    {
      "x": -30,
      "y": -240.17,
      "a": -4.59
    },
    {
      "x": -30,
      "y": -240.36,
      "a": -4.53
    },
    {
      "x": -30,
      "y": -240.58,
      "a": -4.46
    },
    {
      "x": -30,
      "y": -240.76,
      "a": -4.39
    },
    {
      "x": -30,
      "y": -240.95,
      "a": -4.33
    },
    {
      "x": -30,
      "y": -241.16,
      "a": -4.26
    },
    {
      "x": -30,
      "y": -241.35,
      "a": -4.2
    },
    {
      "x": -30,
      "y": -241.53,
      "a": -4.14
    },
    {
      "x": -30,
      "y": -241.74,
      "a": -4.07
    },
    {
      "x": -30,
      "y": -241.92,
      "a": -4.01
    },
    {
      "x": -30,
      "y": -242.11,
      "a": -3.95
    },
    {
      "x": -30,
      "y": -242.31,
      "a": -3.89
    },
    {
      "x": -30,
      "y": -242.49,
      "a": -3.83
    },
    {
      "x": -30,
      "y": -242.67,
      "a": -3.77
    },
    {
      "x": -30,
      "y": -242.87,
      "a": -3.71
    },
    {
      "x": -30,
      "y": -243.05,
      "a": -3.65
    },
    {
      "x": -30,
      "y": -243.23,
      "a": -3.6
    },
    {
      "x": -30,
      "y": -243.42,
      "a": -3.53
    },
    {
      "x": -30,
      "y": -243.6,
      "a": -3.48
    },
    {
      "x": -30,
      "y": -243.79,
      "a": -3.42
    },
    {
      "x": -30,
      "y": -243.97,
      "a": -3.36
    },
    {
      "x": -30,
      "y": -244.14,
      "a": -3.31
    },
    {
      "x": -30,
      "y": -244.31,
      "a": -3.25
    },
    {
      "x": -30,
      "y": -244.5,
      "a": -3.19
    },
    {
      "x": -30,
      "y": -244.69,
      "a": -3.13
    },
    {
      "x": -30,
      "y": -244.84,
      "a": -3.09
    },
    {
      "x": -30,
      "y": -245.02,
      "a": -3.03
    },
    {
      "x": -30,
      "y": -245.19,
      "a": -2.98
    },
    {
      "x": -30,
      "y": -245.35,
      "a": -2.93
    },
    {
      "x": -30,
      "y": -245.54,
      "a": -2.87
    },
    {
      "x": -30,
      "y": -245.7,
      "a": -2.82
    },
    {
      "x": -30,
      "y": -245.86,
      "a": -2.77
    },
    {
      "x": -30,
      "y": -246.05,
      "a": -2.72
    },
    {
      "x": -30,
      "y": -246.21,
      "a": -2.67
    },
    {
      "x": -30,
      "y": -246.39,
      "a": -2.61
    },
    {
      "x": -30,
      "y": -246.54,
      "a": -2.57
    },
    {
      "x": -30,
      "y": -246.7,
      "a": -2.52
    },
    {
      "x": -30,
      "y": -246.86,
      "a": -2.47
    },
    {
      "x": -30,
      "y": -247.03,
      "a": -2.42
    },
    {
      "x": -30,
      "y": -247.19,
      "a": -2.37
    },
    {
      "x": -30,
      "y": -247.34,
      "a": -2.33
    },
    {
      "x": -30,
      "y": -247.51,
      "a": -2.28
    },
    {
      "x": -30,
      "y": -247.66,
      "a": -2.23
    },
    {
      "x": -30,
      "y": -247.81,
      "a": -2.19
    },
    {
      "x": -30,
      "y": -247.98,
      "a": -2.14
    },
    {
      "x": -30,
      "y": -248.13,
      "a": -2.1
    },
    {
      "x": -30,
      "y": -248.28,
      "a": -2.06
    },
    {
      "x": -30,
      "y": -248.44,
      "a": -2.01
    },
    {
      "x": -30,
      "y": -248.59,
      "a": -1.97
    },
    {
      "x": -30,
      "y": -248.73,
      "a": -1.93
    },
    {
      "x": -30,
      "y": -248.9,
      "a": -1.88
    },
    {
      "x": -30,
      "y": -249.04,
      "a": -1.84
    },
    {
      "x": -30,
      "y": -249.18,
      "a": -1.8
    },
    {
      "x": -30,
      "y": -249.34,
      "a": -1.75
    },
    {
      "x": -30,
      "y": -249.48,
      "a": -1.72
    },
    {
      "x": -30,
      "y": -249.62,
      "a": -1.68
    },
    {
      "x": -30,
      "y": -249.77,
      "a": -1.63
    },
    {
      "x": -30,
      "y": -249.91,
      "a": -1.6
    },
    {
      "x": -30,
      "y": -250.05,
      "a": -1.56
    },
    {
      "x": -30,
      "y": -250.2,
      "a": -1.52
    },
    {
      "x": -30,
      "y": -250.35,
      "a": -1.48
    },
    {
      "x": -30,
      "y": -250.47,
      "a": -1.45
    },
    {
      "x": -30,
      "y": -250.61,
      "a": -1.41
    },
    {
      "x": -30,
      "y": -250.75,
      "a": -1.37
    },
    {
      "x": -30,
      "y": -250.89,
      "a": -1.33
    },
    {
      "x": -30,
      "y": -251.02,
      "a": -1.3
    },
    {
      "x": -30,
      "y": -251.15,
      "a": -1.27
    },
    {
      "x": -30,
      "y": -251.29,
      "a": -1.23
    },
    {
      "x": -30,
      "y": -251.42,
      "a": -1.2
    },
    {
      "x": -30,
      "y": -251.54,
      "a": -1.16
    },
    {
      "x": -30,
      "y": -251.67,
      "a": -1.13
    },
    {
      "x": -30,
      "y": -251.82,
      "a": -1.09
    },
    {
      "x": -30,
      "y": -251.93,
      "a": -1.07
    },
    {
      "x": -30,
      "y": -252.05,
      "a": -1.04
    },
    {
      "x": -30,
      "y": -252.19,
      "a": -1
    },
    {
      "x": -30,
      "y": -252.31,
      "a": -0.97
    },
    {
      "x": -30,
      "y": -252.43,
      "a": -0.94
    },
    {
      "x": -30,
      "y": -252.56,
      "a": -0.91
    },
    {
      "x": -30,
      "y": -252.68,
      "a": -0.88
    },
    {
      "x": -30,
      "y": -252.81,
      "a": -0.85
    },
    {
      "x": -30,
      "y": -252.92,
      "a": -0.83
    },
    {
      "x": -30,
      "y": -253.04,
      "a": -0.8
    },
    {
      "x": -30,
      "y": -253.15,
      "a": -0.77
    },
    {
      "x": -30,
      "y": -253.27,
      "a": -0.74
    },
    {
      "x": -30,
      "y": -253.39,
      "a": -0.72
    },
    {
      "x": -30,
      "y": -253.51,
      "a": -0.69
    },
    {
      "x": -30,
      "y": -253.62,
      "a": -0.67
    },
    {
      "x": -30,
      "y": -253.73,
      "a": -0.64
    },
    {
      "x": -30,
      "y": -253.83,
      "a": -0.62
    },
    {
      "x": -30,
      "y": -253.95,
      "a": -0.59
    },
    {
      "x": -30,
      "y": -254.06,
      "a": -0.57
    },
    {
      "x": -30,
      "y": -254.18,
      "a": -0.54
    },
    {
      "x": -30,
      "y": -254.28,
      "a": -0.52
    },
    {
      "x": -30,
      "y": -254.38,
      "a": -0.5
    },
    {
      "x": -30,
      "y": -254.48,
      "a": -0.48
    },
    {
      "x": -30,
      "y": -254.6,
      "a": -0.46
    },
    {
      "x": -30,
      "y": -254.7,
      "a": -0.44
    },
    {
      "x": -30,
      "y": -254.79,
      "a": -0.42
    },
    {
      "x": -30,
      "y": -254.9,
      "a": -0.4
    },
    {
      "x": -30,
      "y": -255,
      "a": -0.38
    },
    {
      "x": -30,
      "y": -255.1,
      "a": -0.36
    },
    {
      "x": -30,
      "y": -255.2,
      "a": -0.34
    },
    {
      "x": -30,
      "y": -255.3,
      "a": -0.32
    },
    {
      "x": -30,
      "y": -255.39,
      "a": -0.31
    },
    {
      "x": -30,
      "y": -255.49,
      "a": -0.29
    },
    {
      "x": -30,
      "y": -255.58,
      "a": -0.27
    },
    {
      "x": -30,
      "y": -255.68,
      "a": -0.26
    },
    {
      "x": -30,
      "y": -255.78,
      "a": -0.24
    },
    {
      "x": -30,
      "y": -255.86,
      "a": -0.23
    },
    {
      "x": -30,
      "y": -255.96,
      "a": -0.21
    },
    {
      "x": -30,
      "y": -256.05,
      "a": -0.2
    },
    {
      "x": -30,
      "y": -256.13,
      "a": -0.19
    },
    {
      "x": -30,
      "y": -256.21,
      "a": -0.17
    },
    {
      "x": -30,
      "y": -256.31,
      "a": -0.16
    },
    {
      "x": -30,
      "y": -256.39,
      "a": -0.15
    },
    {
      "x": -30,
      "y": -256.48,
      "a": -0.14
    },
    {
      "x": -30,
      "y": -256.56,
      "a": -0.12
    },
    {
      "x": -30,
      "y": -256.64,
      "a": -0.11
    },
    {
      "x": -30,
      "y": -256.73,
      "a": -0.1
    },
    {
      "x": -30,
      "y": -256.81,
      "a": -0.09
    },
    {
      "x": -30,
      "y": -256.88,
      "a": -0.09
    },
    {
      "x": -30,
      "y": -256.97,
      "a": -0.08
    },
    {
      "x": -30,
      "y": -257.04,
      "a": -0.07
    },
    {
      "x": -30,
      "y": -257.12,
      "a": -0.06
    },
    {
      "x": -30,
      "y": -257.2,
      "a": -0.05
    },
    {
      "x": -30,
      "y": -257.27,
      "a": -0.05
    },
    {
      "x": -30,
      "y": -257.34,
      "a": -0.04
    },
    {
      "x": -30,
      "y": -257.42,
      "a": -0.03
    },
    {
      "x": -30,
      "y": -257.49,
      "a": -0.03
    },
    {
      "x": -30,
      "y": -257.55,
      "a": -0.02
    },
    {
      "x": -30,
      "y": -257.63,
      "a": -0.02
    },
    {
      "x": -30,
      "y": -257.69,
      "a": -0.01
    },
    {
      "x": -30,
      "y": -257.77,
      "a": -0.01
    },
    {
      "x": -30,
      "y": -257.83,
      "a": -0.01
    },
    {
      "x": -30,
      "y": -257.89,
      "a": -0.01
    },
    {
      "x": -30,
      "y": -257.96,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.02,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.08,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.14,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.22,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.27,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.32,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.38,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.44,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.5,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.55,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.6,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.65,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.71,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.76,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.8,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.86,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.9,
      "a": 0
    },
    {
      "x": -30,
      "y": -258.95,
      "a": 0
    },
    {
      "x": -30,
      "y": -259,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.04,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.08,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.13,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.17,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.2,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.25,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.28,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.32,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.36,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.39,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.43,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.46,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.49,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.53,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.56,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.58,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.61,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.64,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.67,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.69,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.72,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.74,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.76,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.78,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.8,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.82,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.84,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.86,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.88,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.89,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.9,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.92,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.93,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.94,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.95,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.96,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.97,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.98,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.98,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.99,
      "a": 0
    },
    {
      "x": -30,
      "y": -259.99,
      "a": 0
    },
    {
      "x": -30,
      "y": -260,
      "a": 0
    },
  ],

  plane_alex_says_is_ok: [
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -450,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -447.48,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -444.14,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -440.81,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -437.49,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -433.78,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -430.49,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -427.22,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -423.55,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -420.3,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -417.07,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -413.45,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -410.25,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -406.66,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -403.48,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -400.32,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -397.17,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -393.65,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -390.53,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -387.42,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -383.94,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -380.87,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -377.8,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -374.37,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -371.33,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -368.31,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -364.93,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -361.93,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -358.95,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -355.62,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -352.67,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -349.36,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -346.44,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -343.17,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -340.63,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -337.39,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -334.52,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -331.67,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -328.47,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -325.65,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -322.83,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -319.69,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -316.9,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -314.13,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -311.03,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -308.29,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -305.56,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -302.51,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -299.47,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -297.12,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -294.12,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -291.46,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -288.81,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -285.86,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -283.24,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -280.31,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -277.73,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -275.15,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -272.59,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -269.73,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -267.2,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -264.68,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -261.86,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -259.37,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -256.59,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -254.12,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -251.68,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -249.24,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -245.62,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -243.81,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -240.83,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -239.05,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -236.68,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -234.04,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -231.7,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -229.09,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -226.79,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -224.49,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -221.93,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -219.67,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -217.41,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -214.9,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -212.67,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -210.47,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -208.27,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -205.82,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -203.65,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -201.23,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -198.82,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -196.96,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -194.85,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -192.49,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -190.41,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -188.08,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -186.03,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -183.98,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -181.96,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -179.69,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -177.69,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -175.71,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -173.49,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -171.53,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -169.59,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -167.42,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -165.5,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -163.6,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -161.71,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -159.6,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -157.74,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -155.67,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -153.84,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -152.02,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -149.99,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -148.2,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -146.42,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -144.44,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -142.7,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -140.75,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -139.03,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -137.32,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -135.42,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -133.74,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -132.08,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -130.43,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -128.59,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -126.97,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -125.36,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -123.57,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -121.99,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -120.42,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -118.68,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -117.14,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -115.62,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -113.92,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -112.42,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -110.76,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -109.29,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -107.84,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -106.4,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -104.8,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -103.38,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -101.81,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -100.43,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -99.06,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -97.7,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -96.36,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -94.87,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -93.55,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -92.09,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -90.81,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -89.54,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -88.12,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -86.88,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -85.65,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -84.28,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -83.08,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -81.74,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -80.57,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -79.41,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -78.27,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -76.85,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -75.6,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -74.36,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -73.55,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -72.34,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -71.28,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -70.23,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -69.2,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -68.05,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -67.05,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -66.06,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -64.96,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -63.99,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -63.05,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -61.99,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -60.96,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -60.05,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -59.16,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -58.28,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -57.31,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -56.46,
      "y": -195,
      "a": 2.3
    },
    {
      "x": -55.62,
      "y": -195.26,
      "a": 2.22
    },
    {
      "x": -54.8,
      "y": -195.61,
      "a": 2.11
    },
    {
      "x": -53.99,
      "y": -195.95,
      "a": 2.01
    },
    {
      "x": -53.1,
      "y": -196.34,
      "a": 1.89
    },
    {
      "x": -52.31,
      "y": -196.68,
      "a": 1.79
    },
    {
      "x": -51.55,
      "y": -197.02,
      "a": 1.68
    },
    {
      "x": -50.7,
      "y": -197.4,
      "a": 1.57
    },
    {
      "x": -49.96,
      "y": -197.74,
      "a": 1.46
    },
    {
      "x": -49.14,
      "y": -198.12,
      "a": 1.35
    },
    {
      "x": -48.43,
      "y": -198.46,
      "a": 1.25
    },
    {
      "x": -47.74,
      "y": -198.8,
      "a": 1.15
    },
    {
      "x": -46.97,
      "y": -199.18,
      "a": 1.04
    },
    {
      "x": -46.3,
      "y": -199.51,
      "a": 0.94
    },
    {
      "x": -45.64,
      "y": -199.85,
      "a": 0.84
    },
    {
      "x": -45,
      "y": -200.18,
      "a": 0.74
    },
    {
      "x": -44.3,
      "y": -200.55,
      "a": 0.63
    },
    {
      "x": -43.68,
      "y": -200.88,
      "a": 0.53
    },
    {
      "x": -43.08,
      "y": -201.21,
      "a": 0.44
    },
    {
      "x": -42.43,
      "y": -201.58,
      "a": 0.33
    },
    {
      "x": -41.85,
      "y": -201.91,
      "a": 0.23
    },
    {
      "x": -41.3,
      "y": -202.24,
      "a": 0.14
    },
    {
      "x": -40.68,
      "y": -202.61,
      "a": 0.03
    },
    {
      "x": -40.16,
      "y": -202.93,
      "a": -0.06
    },
    {
      "x": -39.64,
      "y": -203.26,
      "a": -0.15
    },
    {
      "x": -39.08,
      "y": -203.62,
      "a": -0.26
    },
    {
      "x": -38.59,
      "y": -203.94,
      "a": -0.35
    },
    {
      "x": -38.11,
      "y": -204.26,
      "a": -0.44
    },
    {
      "x": -37.6,
      "y": -204.62,
      "a": -0.54
    },
    {
      "x": -37.15,
      "y": -204.94,
      "a": -0.63
    },
    {
      "x": -36.72,
      "y": -205.26,
      "a": -0.72
    },
    {
      "x": -36.25,
      "y": -205.62,
      "a": -0.82
    },
    {
      "x": -35.85,
      "y": -205.94,
      "a": -0.91
    },
    {
      "x": -35.46,
      "y": -206.25,
      "a": -1
    },
    {
      "x": -35.04,
      "y": -206.61,
      "a": -1.1
    },
    {
      "x": -34.67,
      "y": -206.92,
      "a": -1.18
    },
    {
      "x": -34.33,
      "y": -207.23,
      "a": -1.27
    },
    {
      "x": -33.95,
      "y": -207.58,
      "a": -1.36
    },
    {
      "x": -33.63,
      "y": -207.89,
      "a": -1.45
    },
    {
      "x": -33.33,
      "y": -208.2,
      "a": -1.53
    },
    {
      "x": -33,
      "y": -208.55,
      "a": -1.63
    },
    {
      "x": -32.72,
      "y": -208.86,
      "a": -1.71
    },
    {
      "x": -32.46,
      "y": -209.17,
      "a": -1.79
    },
    {
      "x": -32.18,
      "y": -209.51,
      "a": -1.88
    },
    {
      "x": -31.94,
      "y": -209.82,
      "a": -1.96
    },
    {
      "x": -31.72,
      "y": -210.12,
      "a": -2.04
    },
    {
      "x": -31.49,
      "y": -210.46,
      "a": -2.13
    },
    {
      "x": -31.29,
      "y": -210.76,
      "a": -2.21
    },
    {
      "x": -31.09,
      "y": -211.1,
      "a": -2.3
    },
    {
      "x": -30.93,
      "y": -211.4,
      "a": -2.38
    },
    {
      "x": -30.78,
      "y": -211.7,
      "a": -2.46
    },
    {
      "x": -30.64,
      "y": -212,
      "a": -2.54
    },
    {
      "x": -30.5,
      "y": -212.34,
      "a": -2.62
    },
    {
      "x": -30.39,
      "y": -212.63,
      "a": -2.7
    },
    {
      "x": -30.28,
      "y": -212.96,
      "a": -2.78
    },
    {
      "x": -30.2,
      "y": -213.26,
      "a": -2.86
    },
    {
      "x": -30.14,
      "y": -213.55,
      "a": -2.93
    },
    {
      "x": -30.08,
      "y": -213.88,
      "a": -3.01
    },
    {
      "x": -30.04,
      "y": -214.17,
      "a": -3.09
    },
    {
      "x": -30.01,
      "y": -214.46,
      "a": -3.16
    },
    {
      "x": -30,
      "y": -214.75,
      "a": -3.23
    },
    {
      "x": -30,
      "y": -215.08,
      "a": -3.31
    },
    {
      "x": -30,
      "y": -215.37,
      "a": -3.38
    },
    {
      "x": -30,
      "y": -215.69,
      "a": -3.46
    },
    {
      "x": -30,
      "y": -215.97,
      "a": -3.53
    },
    {
      "x": -30,
      "y": -216.26,
      "a": -3.6
    },
    {
      "x": -30,
      "y": -216.54,
      "a": -3.66
    },
    {
      "x": -30,
      "y": -216.86,
      "a": -3.74
    },
    {
      "x": -30,
      "y": -217.25,
      "a": -3.83
    },
    {
      "x": -30,
      "y": -217.49,
      "a": -3.89
    },
    {
      "x": -30,
      "y": -217.81,
      "a": -3.96
    },
    {
      "x": -30,
      "y": -218.05,
      "a": -4.02
    },
    {
      "x": -30,
      "y": -218.33,
      "a": -4.08
    },
    {
      "x": -30,
      "y": -218.61,
      "a": -4.15
    },
    {
      "x": -30,
      "y": -218.88,
      "a": -4.21
    },
    {
      "x": -30,
      "y": -219.19,
      "a": -4.28
    },
    {
      "x": -30,
      "y": -219.47,
      "a": -4.34
    },
    {
      "x": -30,
      "y": -219.78,
      "a": -4.41
    },
    {
      "x": -30,
      "y": -220.05,
      "a": -4.47
    },
    {
      "x": -30,
      "y": -220.32,
      "a": -4.53
    },
    {
      "x": -30,
      "y": -220.62,
      "a": -4.6
    },
    {
      "x": -30,
      "y": -220.89,
      "a": -4.66
    },
    {
      "x": -30,
      "y": -221.16,
      "a": -4.72
    },
    {
      "x": -30,
      "y": -221.46,
      "a": -4.78
    },
    {
      "x": -30,
      "y": -221.76,
      "a": -4.85
    },
    {
      "x": -30,
      "y": -221.99,
      "a": -4.9
    },
    {
      "x": -30,
      "y": -222.26,
      "a": -4.95
    },
    {
      "x": -30,
      "y": -222.52,
      "a": -5.01
    },
    {
      "x": -30,
      "y": -222.82,
      "a": -5.07
    },
    {
      "x": -30,
      "y": -223.08,
      "a": -5.13
    },
    {
      "x": -30,
      "y": -223.34,
      "a": -5.18
    },
    {
      "x": -30,
      "y": -223.63,
      "a": -5.24
    },
    {
      "x": -30,
      "y": -223.89,
      "a": -5.29
    },
    {
      "x": -30,
      "y": -224.15,
      "a": -5.34
    },
    {
      "x": -30,
      "y": -224.44,
      "a": -5.4
    },
    {
      "x": -30,
      "y": -224.69,
      "a": -5.45
    },
    {
      "x": -30,
      "y": -224.95,
      "a": -5.5
    },
    {
      "x": -30,
      "y": -225.23,
      "a": -5.56
    },
    {
      "x": -30,
      "y": -225.49,
      "a": -5.61
    },
    {
      "x": -30,
      "y": -225.77,
      "a": -5.66
    },
    {
      "x": -30,
      "y": -226.02,
      "a": -5.71
    },
    {
      "x": -30,
      "y": -226.27,
      "a": -5.76
    },
    {
      "x": -30,
      "y": -226.52,
      "a": -5.8
    },
    {
      "x": -30,
      "y": -226.8,
      "a": -5.86
    },
    {
      "x": -30,
      "y": -227.05,
      "a": -5.9
    },
    {
      "x": -30,
      "y": -227.33,
      "a": -5.95
    },
    {
      "x": -30,
      "y": -227.57,
      "a": -6
    },
    {
      "x": -30,
      "y": -227.82,
      "a": -6.04
    },
    {
      "x": -30,
      "y": -228.06,
      "a": -6.08
    },
    {
      "x": -30,
      "y": -228.33,
      "a": -6.13
    },
    {
      "x": -30,
      "y": -228.57,
      "a": -6.17
    },
    {
      "x": -30,
      "y": -228.81,
      "a": -6.22
    },
    {
      "x": -30,
      "y": -229.08,
      "a": -6.26
    },
    {
      "x": -30,
      "y": -229.32,
      "a": -6.3
    },
    {
      "x": -30,
      "y": -229.56,
      "a": -6.34
    },
    {
      "x": -30,
      "y": -229.83,
      "a": -6.38
    },
    {
      "x": -30,
      "y": -230.06,
      "a": -6.42
    },
    {
      "x": -30,
      "y": -230.3,
      "a": -6.46
    },
    {
      "x": -30,
      "y": -230.56,
      "a": -6.5
    },
    {
      "x": -30,
      "y": -230.79,
      "a": -6.54
    },
    {
      "x": -30,
      "y": -231.05,
      "a": -6.58
    },
    {
      "x": -30,
      "y": -231.28,
      "a": -6.62
    },
    {
      "x": -30,
      "y": -231.51,
      "a": -6.65
    },
    {
      "x": -30,
      "y": -231.77,
      "a": -6.69
    },
    {
      "x": -30,
      "y": -232,
      "a": -6.72
    },
    {
      "x": -30,
      "y": -232.26,
      "a": -6.76
    },
    {
      "x": -30,
      "y": -232.48,
      "a": -6.79
    },
    {
      "x": -30,
      "y": -232.71,
      "a": -6.82
    },
    {
      "x": -30,
      "y": -232.93,
      "a": -6.86
    },
    {
      "x": -30,
      "y": -233.15,
      "a": -6.89
    },
    {
      "x": -30,
      "y": -233.4,
      "a": -6.92
    },
    {
      "x": -30,
      "y": -233.65,
      "a": -6.95
    },
    {
      "x": -30,
      "y": -233.87,
      "a": -6.98
    },
    {
      "x": -30,
      "y": -234.09,
      "a": -7.01
    },
    {
      "x": -30,
      "y": -234.31,
      "a": -7.04
    },
    {
      "x": -30,
      "y": -234.56,
      "a": -7.07
    },
    {
      "x": -30,
      "y": -234.77,
      "a": -7.09
    },
    {
      "x": -30,
      "y": -234.99,
      "a": -7.12
    },
    {
      "x": -30,
      "y": -235.23,
      "a": -7.15
    },
    {
      "x": -30,
      "y": -235.44,
      "a": -7.17
    },
    {
      "x": -30,
      "y": -235.65,
      "a": -7.2
    },
    {
      "x": -30,
      "y": -235.89,
      "a": -7.22
    },
    {
      "x": -30,
      "y": -236.1,
      "a": -7.25
    },
    {
      "x": -30,
      "y": -236.31,
      "a": -7.27
    },
    {
      "x": -30,
      "y": -236.55,
      "a": -7.29
    },
    {
      "x": -30,
      "y": -236.76,
      "a": -7.32
    },
    {
      "x": -30,
      "y": -236.96,
      "a": -7.34
    },
    {
      "x": -30,
      "y": -237.17,
      "a": -7.36
    },
    {
      "x": -30,
      "y": -237.4,
      "a": -7.38
    },
    {
      "x": -30,
      "y": -237.6,
      "a": -7.4
    },
    {
      "x": -30,
      "y": -237.83,
      "a": -7.42
    },
    {
      "x": -30,
      "y": -238.03,
      "a": -7.44
    },
    {
      "x": -30,
      "y": -238.23,
      "a": -7.45
    },
    {
      "x": -30,
      "y": -238.46,
      "a": -7.47
    },
    {
      "x": -30,
      "y": -238.66,
      "a": -7.49
    },
    {
      "x": -30,
      "y": -238.86,
      "a": -7.5
    },
    {
      "x": -30,
      "y": -239.08,
      "a": -7.52
    },
    {
      "x": -30,
      "y": -239.27,
      "a": -7.53
    },
    {
      "x": -30,
      "y": -239.47,
      "a": -7.55
    },
    {
      "x": -30,
      "y": -239.69,
      "a": -7.56
    },
    {
      "x": -30,
      "y": -239.88,
      "a": -7.57
    },
    {
      "x": -30,
      "y": -240.07,
      "a": -7.58
    },
    {
      "x": -30,
      "y": -240.29,
      "a": -7.6
    },
    {
      "x": -30,
      "y": -240.5,
      "a": -7.61
    },
    {
      "x": -30,
      "y": -240.69,
      "a": -7.62
    },
    {
      "x": -30,
      "y": -240.88,
      "a": -7.63
    },
    {
      "x": -30,
      "y": -241.07,
      "a": -7.64
    },
    {
      "x": -30,
      "y": -241.26,
      "a": -7.65
    },
    {
      "x": -30,
      "y": -241.46,
      "a": -7.65
    },
    {
      "x": -30,
      "y": -241.65,
      "a": -7.66
    },
    {
      "x": -30,
      "y": -241.83,
      "a": -7.67
    },
    {
      "x": -30,
      "y": -242.04,
      "a": -7.67
    },
    {
      "x": -30,
      "y": -242.22,
      "a": -7.68
    },
    {
      "x": -30,
      "y": -242.4,
      "a": -7.68
    },
    {
      "x": -30,
      "y": -242.6,
      "a": -7.69
    },
    {
      "x": -30,
      "y": -242.78,
      "a": -7.69
    },
    {
      "x": -30,
      "y": -242.96,
      "a": -7.69
    },
    {
      "x": -30,
      "y": -243.16,
      "a": -7.7
    },
    {
      "x": -30,
      "y": -243.34,
      "a": -7.7
    },
    {
      "x": -30,
      "y": -243.51,
      "a": -7.7
    },
    {
      "x": -30,
      "y": -243.71,
      "a": -7.7
    },
    {
      "x": -30,
      "y": -243.88,
      "a": -7.69
    },
    {
      "x": -30,
      "y": -244.05,
      "a": -7.61
    },
    {
      "x": -30,
      "y": -244.24,
      "a": -7.52
    },
    {
      "x": -30,
      "y": -244.41,
      "a": -7.44
    },
    {
      "x": -30,
      "y": -244.58,
      "a": -7.35
    },
    {
      "x": -30,
      "y": -244.77,
      "a": -7.26
    },
    {
      "x": -30,
      "y": -244.94,
      "a": -7.19
    },
    {
      "x": -30,
      "y": -245.11,
      "a": -7.11
    },
    {
      "x": -30,
      "y": -245.29,
      "a": -7.02
    },
    {
      "x": -30,
      "y": -245.46,
      "a": -6.94
    },
    {
      "x": -30,
      "y": -245.62,
      "a": -6.86
    },
    {
      "x": -30,
      "y": -245.82,
      "a": -6.77
    },
    {
      "x": -30,
      "y": -245.99,
      "a": -6.69
    },
    {
      "x": -30,
      "y": -246.15,
      "a": -6.61
    },
    {
      "x": -30,
      "y": -246.31,
      "a": -6.54
    },
    {
      "x": -30,
      "y": -246.46,
      "a": -6.46
    },
    {
      "x": -30,
      "y": -246.62,
      "a": -6.39
    },
    {
      "x": -30,
      "y": -246.8,
      "a": -6.3
    },
    {
      "x": -30,
      "y": -246.95,
      "a": -6.23
    },
    {
      "x": -30,
      "y": -247.11,
      "a": -6.15
    },
    {
      "x": -30,
      "y": -247.28,
      "a": -6.07
    },
    {
      "x": -30,
      "y": -247.44,
      "a": -6
    },
    {
      "x": -30,
      "y": -247.59,
      "a": -5.93
    },
    {
      "x": -30,
      "y": -247.76,
      "a": -5.85
    },
    {
      "x": -30,
      "y": -247.91,
      "a": -5.77
    },
    {
      "x": -30,
      "y": -248.06,
      "a": -5.7
    },
    {
      "x": -30,
      "y": -248.22,
      "a": -5.62
    },
    {
      "x": -30,
      "y": -248.37,
      "a": -5.55
    },
    {
      "x": -30,
      "y": -248.52,
      "a": -5.48
    },
    {
      "x": -30,
      "y": -248.68,
      "a": -5.41
    },
    {
      "x": -30,
      "y": -248.82,
      "a": -5.34
    },
    {
      "x": -30,
      "y": -248.97,
      "a": -5.27
    },
    {
      "x": -30,
      "y": -249.13,
      "a": -5.19
    },
    {
      "x": -30,
      "y": -249.27,
      "a": -5.13
    },
    {
      "x": -30,
      "y": -249.41,
      "a": -5.06
    },
    {
      "x": -30,
      "y": -249.57,
      "a": -4.99
    },
    {
      "x": -30,
      "y": -249.7,
      "a": -4.92
    },
    {
      "x": -30,
      "y": -249.84,
      "a": -4.85
    },
    {
      "x": -30,
      "y": -249.99,
      "a": -4.78
    },
    {
      "x": -30,
      "y": -250.13,
      "a": -4.72
    },
    {
      "x": -30,
      "y": -250.27,
      "a": -4.65
    },
    {
      "x": -30,
      "y": -250.42,
      "a": -4.58
    },
    {
      "x": -30,
      "y": -250.55,
      "a": -4.52
    },
    {
      "x": -30,
      "y": -250.68,
      "a": -4.46
    },
    {
      "x": -30,
      "y": -250.83,
      "a": -4.39
    },
    {
      "x": -30,
      "y": -250.96,
      "a": -4.32
    },
    {
      "x": -30,
      "y": -251.09,
      "a": -4.26
    },
    {
      "x": -30,
      "y": -251.23,
      "a": -4.19
    },
    {
      "x": -30,
      "y": -251.36,
      "a": -4.13
    },
    {
      "x": -30,
      "y": -251.48,
      "a": -4.07
    },
    {
      "x": -30,
      "y": -251.62,
      "a": -4.01
    },
    {
      "x": -30,
      "y": -251.75,
      "a": -3.95
    },
    {
      "x": -30,
      "y": -251.87,
      "a": -3.89
    },
    {
      "x": -30,
      "y": -252.01,
      "a": -3.82
    },
    {
      "x": -30,
      "y": -252.13,
      "a": -3.77
    },
    {
      "x": -30,
      "y": -252.25,
      "a": -3.71
    },
    {
      "x": -30,
      "y": -252.38,
      "a": -3.64
    },
    {
      "x": -30,
      "y": -252.5,
      "a": -3.59
    },
    {
      "x": -30,
      "y": -252.62,
      "a": -3.53
    },
    {
      "x": -30,
      "y": -252.75,
      "a": -3.47
    },
    {
      "x": -30,
      "y": -252.86,
      "a": -3.42
    },
    {
      "x": -30,
      "y": -252.98,
      "a": -3.36
    },
    {
      "x": -30,
      "y": -253.11,
      "a": -3.3
    },
    {
      "x": -30,
      "y": -253.22,
      "a": -3.25
    },
    {
      "x": -30,
      "y": -253.33,
      "a": -3.19
    },
    {
      "x": -30,
      "y": -253.45,
      "a": -3.13
    },
    {
      "x": -30,
      "y": -253.56,
      "a": -3.08
    },
    {
      "x": -30,
      "y": -253.69,
      "a": -3.02
    },
    {
      "x": -30,
      "y": -253.79,
      "a": -2.97
    },
    {
      "x": -30,
      "y": -253.9,
      "a": -2.92
    },
    {
      "x": -30,
      "y": -254.01,
      "a": -2.87
    },
    {
      "x": -30,
      "y": -254.12,
      "a": -2.82
    },
    {
      "x": -30,
      "y": -254.23,
      "a": -2.77
    },
    {
      "x": -30,
      "y": -254.33,
      "a": -2.72
    },
    {
      "x": -30,
      "y": -254.45,
      "a": -2.66
    },
    {
      "x": -30,
      "y": -254.55,
      "a": -2.61
    },
    {
      "x": -30,
      "y": -254.65,
      "a": -2.57
    },
    {
      "x": -30,
      "y": -254.76,
      "a": -2.51
    },
    {
      "x": -30,
      "y": -254.86,
      "a": -2.47
    },
    {
      "x": -30,
      "y": -254.95,
      "a": -2.42
    },
    {
      "x": -30,
      "y": -255.06,
      "a": -2.37
    },
    {
      "x": -30,
      "y": -255.16,
      "a": -2.32
    },
    {
      "x": -30,
      "y": -255.25,
      "a": -2.28
    },
    {
      "x": -30,
      "y": -255.35,
      "a": -2.23
    },
    {
      "x": -30,
      "y": -255.45,
      "a": -2.18
    },
    {
      "x": -30,
      "y": -255.55,
      "a": -2.14
    },
    {
      "x": -30,
      "y": -255.64,
      "a": -2.09
    },
    {
      "x": -30,
      "y": -255.73,
      "a": -2.05
    },
    {
      "x": -30,
      "y": -255.83,
      "a": -2
    },
    {
      "x": -30,
      "y": -255.92,
      "a": -1.96
    },
    {
      "x": -30,
      "y": -256,
      "a": -1.92
    },
    {
      "x": -30,
      "y": -256.09,
      "a": -1.88
    },
    {
      "x": -30,
      "y": -256.18,
      "a": -1.83
    },
    {
      "x": -30,
      "y": -256.27,
      "a": -1.79
    },
    {
      "x": -30,
      "y": -256.35,
      "a": -1.75
    },
    {
      "x": -30,
      "y": -256.44,
      "a": -1.71
    },
    {
      "x": -30,
      "y": -256.52,
      "a": -1.67
    },
    {
      "x": -30,
      "y": -256.6,
      "a": -1.63
    },
    {
      "x": -30,
      "y": -256.69,
      "a": -1.59
    },
    {
      "x": -30,
      "y": -256.77,
      "a": -1.55
    },
    {
      "x": -30,
      "y": -256.84,
      "a": -1.52
    },
    {
      "x": -30,
      "y": -256.93,
      "a": -1.48
    },
    {
      "x": -30,
      "y": -257,
      "a": -1.44
    },
    {
      "x": -30,
      "y": -257.09,
      "a": -1.4
    },
    {
      "x": -30,
      "y": -257.16,
      "a": -1.37
    },
    {
      "x": -30,
      "y": -257.23,
      "a": -1.33
    },
    {
      "x": -30,
      "y": -257.3,
      "a": -1.3
    },
    {
      "x": -30,
      "y": -257.38,
      "a": -1.26
    },
    {
      "x": -30,
      "y": -257.45,
      "a": -1.23
    },
    {
      "x": -30,
      "y": -257.52,
      "a": -1.2
    },
    {
      "x": -30,
      "y": -257.6,
      "a": -1.16
    },
    {
      "x": -30,
      "y": -257.66,
      "a": -1.13
    },
    {
      "x": -30,
      "y": -257.73,
      "a": -1.1
    },
    {
      "x": -30,
      "y": -257.8,
      "a": -1.06
    },
    {
      "x": -30,
      "y": -257.86,
      "a": -1.03
    },
    {
      "x": -30,
      "y": -257.93,
      "a": -1
    },
    {
      "x": -30,
      "y": -257.99,
      "a": -0.97
    },
    {
      "x": -30,
      "y": -258.05,
      "a": -0.94
    },
    {
      "x": -30,
      "y": -258.12,
      "a": -0.91
    },
    {
      "x": -30,
      "y": -258.18,
      "a": -0.88
    },
    {
      "x": -30,
      "y": -258.24,
      "a": -0.85
    },
    {
      "x": -30,
      "y": -258.29,
      "a": -0.83
    },
    {
      "x": -30,
      "y": -258.36,
      "a": -0.8
    },
    {
      "x": -30,
      "y": -258.41,
      "a": -0.77
    },
    {
      "x": -30,
      "y": -258.47,
      "a": -0.74
    },
    {
      "x": -30,
      "y": -258.52,
      "a": -0.71
    },
    {
      "x": -30,
      "y": -258.58,
      "a": -0.69
    },
    {
      "x": -30,
      "y": -258.63,
      "a": -0.67
    },
    {
      "x": -30,
      "y": -258.68,
      "a": -0.64
    },
    {
      "x": -30,
      "y": -258.73,
      "a": -0.62
    },
    {
      "x": -30,
      "y": -258.78,
      "a": -0.59
    },
    {
      "x": -30,
      "y": -258.83,
      "a": -0.57
    },
    {
      "x": -30,
      "y": -258.88,
      "a": -0.54
    },
    {
      "x": -30,
      "y": -258.93,
      "a": -0.52
    },
    {
      "x": -30,
      "y": -258.97,
      "a": -0.5
    },
    {
      "x": -30,
      "y": -259.02,
      "a": -0.48
    },
    {
      "x": -30,
      "y": -259.06,
      "a": -0.46
    },
    {
      "x": -30,
      "y": -259.11,
      "a": -0.44
    },
    {
      "x": -30,
      "y": -259.15,
      "a": -0.42
    },
    {
      "x": -30,
      "y": -259.19,
      "a": -0.4
    },
    {
      "x": -30,
      "y": -259.23,
      "a": -0.38
    },
    {
      "x": -30,
      "y": -259.27,
      "a": -0.36
    },
    {
      "x": -30,
      "y": -259.31,
      "a": -0.34
    },
    {
      "x": -30,
      "y": -259.34,
      "a": -0.32
    },
    {
      "x": -30,
      "y": -259.38,
      "a": -0.31
    },
    {
      "x": -30,
      "y": -259.41,
      "a": -0.29
    },
    {
      "x": -30,
      "y": -259.45,
      "a": -0.27
    },
    {
      "x": -30,
      "y": -259.48,
      "a": -0.26
    },
    {
      "x": -30,
      "y": -259.51,
      "a": -0.24
    },
    {
      "x": -30,
      "y": -259.54,
      "a": -0.23
    },
    {
      "x": -30,
      "y": -259.57,
      "a": -0.21
    },
    {
      "x": -30,
      "y": -259.6,
      "a": -0.2
    },
    {
      "x": -30,
      "y": -259.63,
      "a": -0.18
    },
    {
      "x": -30,
      "y": -259.65,
      "a": -0.17
    },
    {
      "x": -30,
      "y": -259.68,
      "a": -0.16
    },
    {
      "x": -30,
      "y": -259.71,
      "a": -0.15
    },
    {
      "x": -30,
      "y": -259.73,
      "a": -0.14
    },
    {
      "x": -30,
      "y": -259.75,
      "a": -0.12
    },
    {
      "x": -30,
      "y": -259.77,
      "a": -0.11
    },
    {
      "x": -30,
      "y": -259.79,
      "a": -0.1
    },
    {
      "x": -30,
      "y": -259.82,
      "a": -0.09
    },
    {
      "x": -30,
      "y": -259.83,
      "a": -0.08
    },
    {
      "x": -30,
      "y": -259.85,
      "a": -0.08
    },
    {
      "x": -30,
      "y": -259.87,
      "a": -0.07
    },
    {
      "x": -30,
      "y": -259.88,
      "a": -0.06
    },
    {
      "x": -30,
      "y": -259.9,
      "a": -0.05
    },
    {
      "x": -30,
      "y": -259.91,
      "a": -0.05
    },
    {
      "x": -30,
      "y": -259.92,
      "a": -0.04
    },
    {
      "x": -30,
      "y": -259.94,
      "a": -0.03
    },
    {
      "x": -30,
      "y": -259.95,
      "a": -0.03
    },
    {
      "x": -30,
      "y": -259.96,
      "a": -0.02
    },
    {
      "x": -30,
      "y": -259.97,
      "a": -0.02
    },
    {
      "x": -30,
      "y": -259.97,
      "a": -0.01
    },
    {
      "x": -30,
      "y": -259.98,
      "a": -0.01
    },
    {
      "x": -30,
      "y": -259.99,
      "a": -0.01
    },
    {
      "x": -30,
      "y": -259.99,
      "a": -0.01
    },
    {
      "x": -30,
      "y": -259.99,
      "a": 0
    },
    {
      "x": -30,
      "y": -260,
      "a": 0
    },
  ]
}
